import { ApplicationStatusEnum, CreateApplication } from '@tran-monorepo/interfaces';
import { CreateFile } from '@tran-monorepo/interfaces/files';

const prefix = '[ManagementApplicationDetail]';

export class LoadManagementApplication {
    static readonly type = `${prefix} Load Application`;
    constructor(public readonly applicationId: string) {}
}

export class UpdateManagementApplication {
    static readonly type = `${prefix} Update Application`;
    constructor(
        public readonly applicationId: string,
        public readonly application: Partial<CreateApplication>,
        public readonly status?: ApplicationStatusEnum
    ) {}
}

export class LoadManagementApplicationAttachments {
    static readonly type = `${prefix} Load Application Attachments`;
    constructor(public readonly payload = { pageSize: 20 }) {}
}

export class LoadMoreManagementApplicationAttachments {
    static readonly type = `${prefix} Load More`;
}

export class DownloadManagementAttachment {
    static readonly type = `${prefix} Download Attachment`;
    constructor(public readonly fileId: string) {}
}

export class UploadManagementAttachment {
    static readonly type = `${prefix} Upload Attachment`;
    constructor(public readonly payload: { applicationId: string; fileData: CreateFile; file: File }) {}
}

export class DeleteManagementAttachment {
    static readonly type = `${prefix} Delete Attachment`;
    constructor(public readonly payload: { applicationId: string; fileId: string }) {}
}

export class ResetApplicationDetailState {
    static readonly type = `${prefix} Reset State`;
}

export class LoadAwardCommitteeMeetings {
    static readonly type = `${prefix} Load Meetings`;
}

export class LoadSelectedAwardCommitteeMeeting {
    static readonly type = `${prefix} Load Selected Award Committee Meeting`;
}
